<ng-container
  *ngIf="{suscription: suscription$ | async, nextSuscriptions: nextSuscriptions$ | async, suscriptionUrl: suscriptionUrl$ | async, user: user$ | async} as vm"
>
  <ion-content fullscreen>
    <div id="wrapper" class="ion-padding">
      <div id="suscriptions-list-button" *ngIf="vm.nextSuscriptions?.length" (click)="openSuscriptions()">
        <ion-fab-button color="light" size="small">
          <ion-icon name="today-outline"></ion-icon>
        </ion-fab-button>
        <ion-label>Suscripciones</ion-label>
      </div>
      <div class="header-logo-container">
        <ion-icon src="/assets/icon/tecservice.svg" class="header-logo"></ion-icon>
      </div>
      <div>
        <div id="card">
          <div *ngIf="vm.suscription">
            <div [class]="'subscription-icon '+vm.suscription.name.toLowerCase()">
              <ion-icon [src]="'/assets/icon/'+vm.suscription.name.toLowerCase()+'.svg'"></ion-icon>
              <ion-label *ngIf="vm.suscription.name.toLowerCase()==='sr'">
                Redondo
                <br />
              </ion-label>
              <ion-label *ngIf="vm.suscription.name.toLowerCase()==='srf'">
                Redondo
                <br />
                Flexible
              </ion-label>
              <ion-label *ngIf="vm.suscription.name.toLowerCase()==='ss'">
                Sencillo
                <br />
                fijo
              </ion-label>
              <ion-label *ngIf="vm.suscription.name.toLowerCase()==='ssf'">
                Sencillo
                <br />
                Flexible
              </ion-label>
              <ion-label *ngIf="vm.suscription.name.toLowerCase() === 'pv'">
                Pago
                <br />
                por viaje
              </ion-label>
            </div>
            <div id="period" *ngIf="vm.suscription && vm.suscription.school_period">
              Periodo: {{vm.suscription.school_period.name}}
              <br />
              <span *ngIf="vm.suscription.school_period.name && vm.suscription.name !== 'PV'">
                Vigencia: {{vm.suscription.to | toDatestring:'date'}}
              </span>
            </div>
          </div>
        </div>

        <swiper-container
          #swiper
          [pagination]="true"
          *ngIf="vm.suscription && vm.suscription.suscription_dailies && vm.suscription.suscription_dailies.length"
          id="subscriptions"
        >
          <ng-template ngFor let-item [ngForOf]="vm.suscription.suscription_dailies" let-i="index" let-last="last">
            <swiper-slide *ngIf="vm.suscription.type === 'complete' && i % 2 === 0">
              <ion-row>
                <ion-col size="12">
                  <p style="padding: 0; margin: -5px 0px"><strong>{{item.dotw | dayOfWeek}}</strong></p>
                </ion-col>
                <ion-col>
                  <ion-card>
                    <ion-item color="primary">
                      <ion-icon src="/assets/icon/transportec-ida.svg" slot="start"></ion-icon>
                      <ion-label>LLEGADA</ion-label>
                    </ion-item>

                    <ion-card-content (click)="goSubscription(item)">
                      <p hidden>
                        <strong>Zona:</strong>
                        {{item.zone_name}}
                      </p>
                      <p>
                        <strong>Ruta:</strong>
                        {{item.route_name}}
                      </p>
                      <p>
                        <strong>Parada:</strong>
                        {{item.stop_name}}
                      </p>
                      <p>
                        <strong>Hora:</strong>
                        {{item.departure_time | slice:0:5}}
                      </p>
                      <p class="ticket">Ver boleto</p>
                    </ion-card-content>
                  </ion-card>
                </ion-col>
                <ion-col>
                  <ion-card>
                    <ion-item color="primary">
                      <ion-icon src="/assets/icon/transportec-regreso.svg" slot="start"></ion-icon>
                      <ion-label>SALIDA</ion-label>
                    </ion-item>

                    <ion-card-content (click)="goSubscription(vm.suscription.suscription_dailies[i+1])">
                      <p hidden>
                        <strong>Zona:</strong>
                        {{vm.suscription.suscription_dailies[i+1].zone_name}}
                      </p>
                      <p>
                        <strong>Ruta:</strong>
                        {{vm.suscription.suscription_dailies[i+1].route_name}}
                      </p>
                      <p>
                        <strong>Parada:</strong>
                        {{vm.suscription.suscription_dailies[i+1].stop_name}}
                      </p>
                      <p>
                        <strong>Hora:</strong>
                        {{vm.suscription.suscription_dailies[i+1].departure_time | slice:0:5}}
                      </p>
                      <p class="ticket">Ver boleto</p>
                    </ion-card-content>
                  </ion-card>
                </ion-col>
              </ion-row>
            </swiper-slide>
            <swiper-slide *ngIf="vm.suscription.type !== 'complete'">
              <ion-row>
                <ion-col size="12">
                  <p style="padding: 0; margin: -5px 0px"><strong>{{item.dotw | dayOfWeek}}</strong></p>
                </ion-col>
                <ion-col>
                  <ion-card>
                    <ion-item color="primary" *ngIf="vm.suscription.type === 'go'">
                      <ion-icon src="/assets/icon/transportec-ida.svg" slot="start"></ion-icon>
                      <ion-label>LLEGADA</ion-label>
                    </ion-item>
                    <ion-item color="primary" *ngIf="vm.suscription.type === 'return'">
                      <ion-icon src="/assets/icon/transportec-regreso.svg" slot="start"></ion-icon>
                      <ion-label>SALIDA</ion-label>
                    </ion-item>

                    <ion-card-content (click)="goSubscription(item)">
                      <p hidden>
                        <strong>Zona:</strong>
                        {{item.zone_name}}
                      </p>
                      <p>
                        <strong>Ruta:</strong>
                        {{item.route_name}}
                      </p>
                      <p>
                        <strong>Parada:</strong>
                        {{item.stop_name}}
                      </p>
                      <p>
                        <strong>Hora:</strong>
                        {{item.departure_time | slice:0:5}}
                      </p>
                      <p class="ticket">Ver boleto</p>
                    </ion-card-content>
                  </ion-card>
                </ion-col>
              </ion-row>
            </swiper-slide>
          </ng-template>
        </swiper-container>

        <ion-button shape="block" color="light" icon-start class="bluetext" (click)="goZones()">
          <ion-icon src="/assets/icon/transportec-schedule.svg"></ion-icon>
          <ion-label>Rutas y horarios</ion-label>
        </ion-button>

        <ion-button shape="block" color="light" icon-start class="bluetext" (click)="goTickets()">
          <ion-icon src="/assets/icon/tickets.svg"></ion-icon>
          <ion-label>Comprar boletos</ion-label>
        </ion-button>

        <ion-button
          shape="block"
          color="light"
          icon-start
          class="bluetext"
          (click)="goSubscribe(vm.suscription, vm.suscriptionUrl)"
          *ngIf="vm.suscriptionUrl && vm.suscription"
        >
          <ion-icon src="/assets/icon/tickets.svg"></ion-icon>
          <ion-label>Suscribir</ion-label>
        </ion-button>
      </div>
    </div>
  </ion-content>
</ng-container>
